module.exports = __webpack_public_path__ + "b1ca79dbbb82a7d31a8dad22baebe3dc.fbx";